export default __webpack_public_path__ + "static/media/edot_cloudxier2.b4846a90.png";